import { render, staticRenderFns } from "./doorType.vue?vue&type=template&id=3698cee8&scoped=true&"
import script from "./doorType.vue?vue&type=script&lang=js&"
export * from "./doorType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3698cee8",
  null
  
)

export default component.exports